if (document.querySelector('.js-closeAlert')) {
  document.querySelector('.js-closeAlert').addEventListener('click', event => {
    event.target.closest('.alert-row').remove();
    if (document.querySelector('body').classList.contains('alert-true')) {
      document.querySelector('body').classList.remove('alert-true')
    }
  })
}